import React from "react";
import "./App.css";
import salahImg from "./Assets/salah.png";
import lookmanImg from "./Assets/lookman.png";
import sorlothImg from "./Assets/sorloth.png";
import cleatmarketLogo from "./Assets/cleatmarketlogo.png";
import appView2 from "./Assets/app-view/cleat3.png";
import appView4 from "./Assets/app-view/cleat5.png";
import appView5 from "./Assets/app-view/image5.png";
import appView6 from "./Assets/app-view/image6.png";
import appView8 from "./Assets/app-view/cleat1.png";
import appView9 from "./Assets/app-view/cleat6.png";
import devrimSahinImg from "./Assets/footballers/devrimsahin.png";
import efeAkmanImg from "./Assets/footballers/efeakman.png";
import yigitEfeDemirImg from "./Assets/footballers/yigitefedemir.png";

const transfers = [
  {
    player: "Mohammed Salah",
    from: "Liverpool",
    to: "Galatasaray",
    fee: "30M €",
    type: "Bonservis",
    image: salahImg,
  },
  {
    player: "Ademola Lookman",
    from: "Atalanta Bergamo",
    to: "Galatasaray",
    fee: "40M €",
    type: "Bonservis",
    image: lookmanImg,
  },
  {
    player: "Alexander Sørloth",
    from: "Atletico Madrid",
    to: "Fenerbahçe",
    fee: "Kiralık",
    type: "Kiralık",
    image: sorlothImg,
  },
];

const featuredPlayers = [
  {
    name: "Devrim Şahin",
    club: "Beşiktaş",
    position: "Sol Kanat",
    marketValue: "100 bin €",
    image: devrimSahinImg,
  },
  {
    name: "Yiğit Efe Demir",
    club: "Fenerbahçe",
    position: "Stoper",
    marketValue: "1.50 mil. €",
    image: yigitEfeDemirImg,
  },
  {
    name: "Efe Akman",
    club: "Galatasaray",
    position: "Ön Libero",
    marketValue: "500 bin €",
    image: efeAkmanImg,
  },
];

const footerSections = [
  {
    title: "Platform",
    links: [
      { label: "Nasıl Çalışır", href: "#gol-info" },
      { label: "Transfer Piyasası", href: "#transfers" },
      { label: "Öne Çıkan Oyuncular", href: "#players" },
      { label: "Scout Merkezi", href: "#scout" },
    ],
  },
  {
    title: "Piyasalar",
    links: [
      { label: "Bonservis Payları", href: "#transfers" },
      { label: "Gelişen Yetenekler", href: "#players" },
      { label: "Likidite Havuzu", href: "#about" },
      { label: "Kulüp Endeksleri", href: "#about" },
    ],
  },
];

const contactItems = [
  {
    label: "Piyasa Hattı",
    value: "0850 000 00 00",
    href: "tel:+908500000000",
    emphasized: true,
  },
  {
    label: "Adres",
    value: "Maslak Mah. Eski Büyükdere Cad. No:1 Sarıyer / İstanbul",
  },
  {
    label: "E-posta",
    value: "destek@cleatmarket.com",
    href: "mailto:destek@cleatmarket.com",
  },
];

const socialLinks = [
  { label: "Instagram", href: "#", icon: "instagram" },
  { label: "X", href: "#", icon: "x" },
  { label: "YouTube", href: "#", icon: "youtube" },
  { label: "LinkedIn", href: "#", icon: "linkedin" },
];

const storeButtons = [
  {
    label: "App Store",
    sublabel: "'dan indir",
    icon: "apple",
  },
  {
    label: "Google Play",
    sublabel: "'den indir",
    icon: "google-play",
  },
];

const appScreens = [
  { image: appView2, title: "Oyuncu listesi" },
  { image: appView8, title: "Home" },
  { image: appView6, title: "Market" },
  { image: appView4, title: "Takimini Sec" },  
  { image: appView9, title: "Fanatik" },
  { image: appView5, title: "Discover" },
];

function SocialIcon({ type }) {
  switch (type) {
    case "instagram":
      return (
        <svg viewBox="0 0 24 24" className="footer-social-icon" aria-hidden="true">
          <rect x="3.5" y="3.5" width="17" height="17" rx="5" ry="5" />
          <circle cx="12" cy="12" r="4.1" />
          <circle cx="17.4" cy="6.7" r="1.1" className="footer-social-icon-fill" />
        </svg>
      );
    case "x":
      return (
        <svg viewBox="0 0 24 24" className="footer-social-icon" aria-hidden="true">
          <path d="M5 4.5 10.8 12 5.4 19.5" />
          <path d="M9.3 4.5 18.7 19.5" />
          <path d="M13.3 12 19 4.5" />
        </svg>
      );
    case "youtube":
      return (
        <svg viewBox="0 0 24 24" className="footer-social-icon" aria-hidden="true">
          <path d="M21 12c0 2.2-.2 3.7-.6 4.5-.3.7-.9 1.3-1.6 1.6-.8.4-3.1.6-6.8.6s-6-.2-6.8-.6c-.7-.3-1.3-.9-1.6-1.6C3.2 15.7 3 14.2 3 12s.2-3.7.6-4.5c.3-.7.9-1.3 1.6-1.6.8-.4 3.1-.6 6.8-.6s6 .2 6.8.6c.7.3 1.3.9 1.6 1.6.4.8.6 2.3.6 4.5Z" />
          <path d="m10 8.6 5.8 3.4-5.8 3.4Z" className="footer-social-icon-fill" />
        </svg>
      );
    case "linkedin":
      return (
        <svg viewBox="0 0 24 24" className="footer-social-icon" aria-hidden="true">
          <rect x="4" y="9.5" width="3.2" height="10" className="footer-social-icon-fill" />
          <circle cx="5.6" cy="6.3" r="1.6" className="footer-social-icon-fill" />
          <path d="M10 9.5h3.1v1.4c.7-1 1.8-1.7 3.5-1.7 3 0 4.4 1.9 4.4 5.1v5.2h-3.2v-4.7c0-1.6-.6-2.6-2.1-2.6-1.4 0-2.4 1-2.4 2.6v4.7H10Z" className="footer-social-icon-fill" />
        </svg>
      );
    default:
      return null;
  }
}

function StoreBadgeIcon({ type }) {
  switch (type) {
    case "apple":
      return (
        <svg viewBox="0 0 24 24" className="store-badge-icon" aria-hidden="true">
          <path
            d="M15.2 3.3c0 1-.4 2-1.1 2.7-.7.7-1.8 1.2-2.8 1.1-.1-1 .3-2 .9-2.7.7-.8 1.8-1.3 3-1.1ZM18.4 17.5c-.5 1.2-1.1 2.3-2 3.3-.8.9-1.7 1.8-3 1.8-1.2 0-1.6-.7-3-.7s-1.8.7-3 .7c-1.3 0-2.2-.8-3-1.7C2.6 19 1 15.6 1 12.6c0-2.3 1.3-4.5 3.3-5.5 1.1-.6 2.4-.9 3.6-.9 1.3 0 2.4.8 3 .8.6 0 2-.9 3.5-.8.6 0 2.4.2 3.6 1.9-2.8 1.6-2.3 5.6.4 6.7Z"
            className="store-badge-icon-fill"
          />
        </svg>
      );
    case "google-play":
      return (
        <svg viewBox="0 0 24 24" className="store-badge-icon" aria-hidden="true">
          <path d="M4 3.7 13.8 13 4 20.3Z" className="store-badge-icon-fill" />
          <path d="M15.2 14.3 6.6 22l11.6-6.4c1.8-1 1.8-2.1 0-3.1l-3-1.7Z" className="store-badge-icon-fill" />
          <path d="M15.2 11.7 6.6 4 18.2 10.4c1.8 1 1.8 2.1 0 3.1l-3 1.7Z" className="store-badge-icon-fill" />
        </svg>
      );
    default:
      return null;
  }
}

function App() {
  return (
    <div className="page" id="top">
      {/* Üst kısım / Hero */}
      <header className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <img src={cleatmarketLogo} alt="CleatMarket" className="hero-brand-image" />
          <h1 className="sr-only">CleatMarket</h1>
          <p className="hero-subtitle">
            Geleceğine inandığın futbolcuya{" "}
            <a href="#gol-info" className="hero-link">
              GOL
            </a>{" "}
            ile yatırım yap.
          </p>

          <div className="hero-actions">
            <a href="#transfers" className="hero-button">
              Transferleri Gör
            </a>
            <a href="#about" className="hero-button hero-button-secondary">
              CleatMarket&apos;i indir
            </a>
          </div>
        </div>
      </header>

      {/* Ana içerik */}
      <main className="content">
        {/* Transfer Haberleri */}
        <section id="transfers" className="section">
          <h2 className="section-title">Son Transfer Haberleri</h2>
          <p className="section-description">
            Dünyanın önde gelen liglerinden seçilmiş son transfer hareketleri.
          </p>
          <div className="card-list">
            {transfers.map((t, index) => (
              <article key={index} className="card">
                <div className="card-player-header">
                  <img src={t.image} alt={t.player} className="player-photo" />
                  <h3 className="card-title">{t.player}</h3>
                </div>
                <p className="card-line">
                  <span className="badge badge-from">{t.from}</span>
                  <span className="arrow">→</span>
                  <span className="badge badge-to">{t.to}</span>
                </p>
                <p className="card-line">
                  <span className="label">Transfer Türü:</span> {t.type}
                </p>
                <p className="card-line">
                  <span className="label">Bonservis:</span> {t.fee}
                </p>
              </article>
            ))}
          </div>
        </section>

        {/* Genç Yetenekler */}
        <section id="players" className="section">
          <h2 className="section-title">Genç Yetenekler</h2>
          <p className="section-description">
            Geleceğin yıldızlarına yatırım yap. CleatMarket'e katıl hemen ilk GOL'unu kap.
          </p>
          <div className="card-list">
            {featuredPlayers.map((p, index) => (
              <article key={index} className="card card-player">
                <div className="card-player-header">
                  <img src={p.image} alt={p.name} className="player-photo" />
                  <h3 className="card-title">{p.name}</h3>
                </div>
                <p className="card-line">
                  <span className="label">Kulüp:</span> {p.club}
                </p>
                <p className="card-line">
                  <span className="label">Mevki:</span> {p.position}
                </p>
                <p className="card-line">
                  <span className="label">Piyasa Değeri:</span> {p.marketValue}
                </p>
              </article>
            ))}
          </div>
        </section>

        {/* Scout Haberleri */}
        <section id="scout" className="section section-scout">
          <h2 className="section-title">Scout haberlerini kaçırma</h2>
          <p className="section-description">
            Akademi liglerinden Avrupa devlerine uzanan keşif raporlarını e-posta kutunda görmek
            için şimdi katıl. Üye olup bildirimleri aç, kimse duymadan potansiyel yıldızları sen
            yakala.
          </p>
          <div className="scout-grid">
            <article className="scout-card">
              <h3>Haftalık Scout Bülteni</h3>
              <p>Her pazartesi gönderilen kısa özetlerle radarındaki oyuncuları takip et.</p>
            </article>
            <article className="scout-card">
              <h3>Özel İçerik</h3>
              <p>Scout ekibimizin saha gözlemlerini, verilerini ve video notlarını kilit açılmış şekilde al.</p>
            </article>
            <article className="scout-card">
              <h3>Üye Ol</h3>
              <p>Mail adresini bırak, “PRO SCOUT” planı için beta davetini ilk sen kap.</p>
            </article>
          </div>
        </section>

        {/* GOL Bilgisi */}
        <section id="gol-info" className="section section-gol">
          <h2 className="section-title">GOL nedir?</h2>
          <p className="section-description">
            GOL gelir ortaklığı lisansı konseptini temsil eder; futbol paydaşlarının projeleri
            için taraftarlarıyla birlikte değer yaratmasını sağlayan yenilikçi bir finansman
            yaklaşımıdır.
          </p>
        </section>

        {/* Hakkında / Footer Info */}
        <section id="about" className="section section-about">
          <div className="app-download-panel">
            <p className="app-download-eyebrow">Yatırıma hemen başlamak için</p>
            <h2 className="app-download-title">Uygulamayı Ücretsiz İndir</h2>
            <p className="app-download-description">
              Portföyünü cebinden yönet, oyuncu kartlarını takip et ve bonservis piyasasındaki
              hareketleri anlık olarak yakala.
            </p>
            <div className="app-download-actions">
              {storeButtons.map((button) => (
                <button key={button.label} type="button" className="store-badge">
                  <StoreBadgeIcon type={button.icon} />
                  <span className="store-badge-copy">
                    <strong>{button.label}</strong>
                    <span>{button.sublabel}</span>
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="app-preview-shell">
            <div className="app-preview-copy">
              <span className="app-preview-kicker">Mobil Deneyim</span>
              <h3>CleatMarket her an elinin altında</h3>
              <p>
                Transfer haberleri, oyuncu performans grafikleri, fiyat hareketleri ve işlem
                ekranları tek uygulamada birleşiyor. Aşağıdaki ekranlar ürün deneyiminin farklı
                parçalarını gösterir.
              </p>
            </div>

            <div className="app-device-grid">
              {appScreens.map((screen, index) => {
                const positionClass =
                  index % 3 === 0 ? "is-left" : index % 3 === 1 ? "is-center" : "is-right";

                return (
                <article key={screen.title} className={`app-device-card ${positionClass}`}>
                  <div className="phone-frame">
                    <img src={screen.image} alt={screen.title} className="phone-screen" />
                  </div>
                </article>
                );
              })}
            </div>
          </div>
        </section>
      </main>

      {/* Alt Kısım */}
      <footer className="footer">
        <div className="footer-shell">
          <div className="footer-grid">
            <div className="footer-column footer-brand-column">
              <a href="#top" className="footer-brand-mark" aria-label="CleatMarket ana sayfa">
                <img src={cleatmarketLogo} alt="CleatMarket" className="footer-brand-image" />
              </a>
              <p className="footer-brand-copy">
                Futbolcu bonservislerini takip et, oyuncu potansiyelini analiz et ve transfer
                piyasasını hisse mantığıyla yorumla.
              </p>
            </div>

            {footerSections.map((section) => (
              <div key={section.title} className="footer-column">
                <h3 className="footer-title">{section.title}</h3>
                <nav className="footer-links" aria-label={section.title}>
                  {section.links.map((link) => (
                    <a key={link.label} href={link.href} className="footer-link">
                      {link.label}
                    </a>
                  ))}
                </nav>
              </div>
            ))}

            <div className="footer-column footer-contact-column">
              {contactItems.map((item) => (
                <div key={item.label} className="footer-contact-item">
                  <h3 className="footer-title">{item.label}</h3>
                  {item.href ? (
                    <a
                      href={item.href}
                      className={`footer-contact-value${item.emphasized ? " is-emphasized" : ""}`}
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p className={`footer-contact-value${item.emphasized ? " is-emphasized" : ""}`}>
                      {item.value}
                    </p>
                  )}
                </div>
              ))}

              <div className="footer-contact-item">
                <h3 className="footer-title">Sosyal Medya</h3>
                <div className="footer-socials">
                  {socialLinks.map((item) => (
                    <a key={item.label} href={item.href} className="footer-social-link" aria-label={item.label}>
                      <SocialIcon type={item.icon} />
                      <span className="sr-only">{item.label}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="footer-column footer-note-column">
              <p className="footer-note">
                CleatMarket üzerindeki oyuncu payları, bonservis değeri ve likidite göstergeleri
                bilgilendirme amaçlıdır. Futbolcu performansı, transfer ihtimali ve piyasa ilgisi
                değişkenlik gösterebilir; nihai karar kullanıcı değerlendirmesine bağlıdır.
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} CleatMarket. Tüm hakları saklıdır.</p>
            <a href="#top" className="footer-backtop">
              <span className="footer-backtop-icon" aria-hidden="true">
                ↑
              </span>
              Yukarı Dön
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
